export default __webpack_public_path__ + "static/media/October2014.438b112c.png";